import Button from './Button';
import Text from './Text';
import { useReseau } from '../hooks/useReseau';
import { t } from '../i18n/langue';

/**
 * Le bandeau hors ligne — #24, #86.
 *
 * Il ne dit pas « vous êtes hors ligne » mais **ce que ça change** : l'app
 * fonctionne, elle ne se met simplement plus à jour. Un utilisateur au sous-sol
 * n'a pas besoin qu'on lui apprenne qu'il n'a pas de réseau, il a besoin de
 * savoir s'il peut faire confiance à ce qu'il voit.
 *
 * Fondé sur l'échec **observé** des requêtes, jamais sur `navigator.onLine` —
 * voir `useReseau.ts` pour la raison, qui est le cœur de la décision.
 *
 * ## Pourquoi il porte un bouton
 *
 * Constaté à l'écran : hors ligne au démarrage, `/user` échoue, la coque reste
 * sur « Chargement… » — et **rien ne réessaie**. Le réseau revenu, l'app y restait
 * bloquée, parce qu'aucune requête ne repartait pour constater le retour.
 *
 * Un écran de chargement avec un bandeau reste un cul-de-sac, ce que #19 refuse.
 * Le rechargement est brutal mais honnête : il rejoue tout le démarrage, il est
 * gratuit maintenant que la coque est précachée, et **il est à un geste** — la
 * même règle que l'envoi différé de #24, qui n'automatise rien mais ne perd rien.
 */
export default function BandeauReseau() {
    const { horsLigne } = useReseau();

    if (!horsLigne) return null;

    return (
        <div role="status" className="flex shrink-0 items-center gap-3 bg-amber-50 px-4 py-2">
            <Text variante="petit" className="flex-1 leading-snug text-amber-900">
                {t('composants.horsLigne')}
            </Text>
            <Button
                libelle={t('commun.reessayer')}
                onPress={() => window.location.reload()}
                variante="discret"
                espacement="aucun"
                className="shrink-0 text-amber-900 underline"
            />
        </div>
    );
}
